<template>
    <div class="ls-service-list">
        <div
            v-for="service in allServices"
            :key="service.__typename + service.id"
            test-id="service"
        >
            <LsServiceDetails v-if="showClickableItem()" :service="service" @click="handleClick" />
            <LsServiceDetails v-else :service="service" />
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import LsServiceDetails from '@/components/LsServiceDetails/LsServiceDetails.vue';

export default {
    name: 'LsServiceList',
    components: {
        LsServiceDetails,
    },
    props: {
        services: VueTypes.arrayOf(
            VueTypes.shape({
                __typename: VueTypes.oneOf(['Schedule', 'Recommendation', 'RequiredService'])
                    .isRequired,
                id: VueTypes.string.isRequired,
                type: VueTypes.string,
            }).isRequired.loose
        ).isRequired,
        exclude: VueTypes.arrayOf(
            VueTypes.shape({
                __typename: VueTypes.oneOf(['Schedule', 'Recommendation', 'RequiredService'])
                    .isRequired,
                id: VueTypes.string.isRequired,
                type: VueTypes.string,
            }).isRequired.loose
        ),
    },
    computed: {
        allServices() {
            return _.filter(this.services, (service) => {
                return !_.some(this.exclude, ({ id, __typename }) => {
                    return id === service.id && __typename === service.__typename;
                });
            });
        },
        hasClickListener() {
            return this.$listeners && this.$listeners.click;
        },
    },
    methods: {
        handleClick({ id, __typename }) {
            this.$emit('click', { id, __typename });
        },
        showClickableItem() {
            return this.hasClickListener;
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-service-list {
    div:not(:last-of-type) {
        margin-bottom: 15px;
    }
}
</style>
